import React, { useState } from 'react';

const ImageCarousel = () => {
  const images = [
    '/images/BurgerBarn_restaurant-front-1200x900.jpg',
    '/images/BurgerBarn_restaurant-corner-1200x916.jpg',
    '/images/BurgerBarn_restaurant-side-1200x900.jpg',
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="image-carousel">
      <button className="carousel-button prev" onClick={handlePrev}>
        <span></span>
      </button>
      <img src={images[currentIndex]} alt={`Carousel ${currentIndex + 1}`} className="carousel-image" />
      <button className="carousel-button next" onClick={handleNext}>
        <span></span>
      </button>
    </div>
  );
};

export default ImageCarousel;